// extracted by mini-css-extract-plugin
export default {"flex-space":"Bundles_flex-space__DHUh9","view-product-list-item":"Bundles_view-product-list-item__Uk8-C"};